const whenTextTrackCuesReady = (
  trackElement: HTMLTrackElement,
  onCuesReady: (trackCues: TextTrackCue[]) => void,
): void => {
  let cueListBound = false;

  const onTrackLoad = (): void => {
    const textTrack = trackElement.track;
    if (!textTrack) {
      return;
    }
    textTrack.mode = "hidden";

    if (cueListBound || !textTrack.cues || textTrack.cues.length === 0) {
      return;
    }
    cueListBound = true;
    onCuesReady(Array.from(textTrack.cues));
  };

  trackElement.addEventListener("load", onTrackLoad);
  onTrackLoad();
};

export { whenTextTrackCuesReady };
